document.addEventListener('DOMContentLoaded',()=>{
  document.body.classList.add('is-loading');
  const loader=document.querySelector('[data-loader]');
  setTimeout(()=>{loader?.classList.add('is-hidden');document.body.classList.remove('is-loading')},850);

  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})
  },{threshold:.12});
  document.querySelectorAll('.section,.footer,.product-page').forEach(el=>{el.classList.add('reveal');observer.observe(el)});

  const header=document.querySelector('[data-header]');
  const scroll=()=>header?.classList.toggle('is-scrolled',window.scrollY>20);
  scroll();addEventListener('scroll',scroll,{passive:true});

  const drawer=document.querySelector('[data-cart-drawer]');
  const close=()=>{drawer?.classList.remove('open');drawer?.setAttribute('aria-hidden','true')};
  const open=async()=>{drawer?.classList.add('open');drawer?.setAttribute('aria-hidden','false');await renderCart()};
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-cart-open]'))open();
    if(e.target.closest('[data-cart-close]'))close();
    if(e.target.closest('[data-size-open]'))document.querySelector('[data-size-modal]')?.classList.add('open');
    if(e.target.closest('[data-size-close]'))document.querySelector('[data-size-modal]')?.classList.remove('open');
  });

  async function renderCart(){
    const body=document.querySelector('[data-cart-body]');
    if(!body)return;

    body.innerHTML='<p>Loading…</p>';

    const cart=await fetch('/cart.js').then(r=>r.json());
    const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
    const formatMoney=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{
      style:'currency',
      currency
    }).format(cents/100);

    if(!cart.items.length){
      const dropUrl=body.dataset.dropUrl||'/';
      body.innerHTML=`<div class="bf-empty-cart"><div class="bf-empty-cart__mark">BF</div><h2>Your bag is empty</h2><p>DROP 001 is waiting.</p><a class="button button--wide" href="${dropUrl}">Shop DROP 001</a></div>`;
      return;
    }

    body.innerHTML=cart.items.map(item=>`
      <div class="cart-item">
        ${item.image?`<img src="${item.image}" alt="">`:''}
        <div>
          <strong>${item.product_title}</strong>
          ${item.variant_title&&item.variant_title!=='Default Title'?`<br><small>${item.variant_title}</small>`:''}
          <p>${formatMoney(item.final_line_price)}</p>
          <button class="bf-drawer-remove" type="button" data-remove-line="${item.key}">Remove</button>
        </div>
      </div>
    `).join('')+`
      <div class="bf-cart-drawer-actions">
        <a class="button button--wide" href="/checkout">Checkout · ${formatMoney(cart.total_price)}</a>
        <button class="bf-drawer-clear" type="button" data-clear-cart>Clear cart</button>
      </div>
    `;
  }

  document.addEventListener('submit',async e=>{
    const form=e.target.closest('form[action*="/cart/add"]'); if(!form)return;
    e.preventDefault(); const btn=form.querySelector('[type=submit]'); const old=btn.textContent;
    btn.disabled=true; btn.textContent='ADDING…';
    try{
      const res=await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      if(!res.ok)throw new Error('Unable to add item');
      open();
    }catch(err){alert(err.message)}
    finally{btn.disabled=false;btn.textContent=old}
  });

  document.querySelectorAll('[data-product-root]').forEach(root=>{
    const form=root.querySelector('[data-product-form]'),variantSelect=root.querySelector('[data-variant-select]'),variantsEl=root.querySelector('[data-product-variants]');
    const items=[...root.querySelectorAll('[data-gallery-color]')],addButton=root.querySelector('#MainAddToBag'),priceEl=root.querySelector('[data-product-price]'),stickyPrice=document.querySelector('[data-sticky-price]');
    const variants=variantsEl?JSON.parse(variantsEl.textContent):[];
    const normalize=v=>{v=(v||'').toLowerCase();if(v.includes('white'))return'white';if(v.includes('black'))return'black';return v.replace(/\s+/g,'-')};
    const selected=()=>[...root.querySelectorAll('[data-option-position]:checked')].sort((a,b)=>+a.dataset.optionPosition-+b.dataset.optionPosition).map(i=>i.value);
    const showColor=color=>{const key=normalize(color);let matched=false;items.forEach(item=>{const visible=item.dataset.galleryColor==='all'||item.dataset.galleryColor===key;item.hidden=!visible;if(visible&&item.dataset.galleryColor===key)matched=true});if(!matched)items.forEach(i=>i.hidden=false)};
    const sync=()=>{if(!variantSelect||!variants.length)return;const opts=selected();const v=variants.find(x=>x.options.every((o,i)=>o===opts[i]));if(!v)return;variantSelect.value=v.id;if(addButton){addButton.disabled=!v.available;addButton.textContent=v.available?'Add to bag':'Sold out'}const money=(v.price/100).toFixed(2);const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';const formatted=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(v.price/100);if(priceEl)priceEl.textContent=formatted;if(stickyPrice)stickyPrice.textContent=formatted;const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)};
    root.querySelectorAll('[data-option-position]').forEach(input=>input.addEventListener('change',()=>{sync();if(input.dataset.colorValue)showColor(input.dataset.colorValue)}));
    const checked=root.querySelector('[data-color-value]:checked');if(checked)showColor(checked.dataset.colorValue);sync();
  });
  document.addEventListener('click',e=>{const b=e.target.closest('[data-zoom-open]');if(b){const item=b.closest('[data-zoom-src]'),modal=document.querySelector('[data-zoom-modal]'),img=modal?.querySelector('[data-zoom-image]');if(item&&modal&&img){img.src=item.dataset.zoomSrc;modal.classList.add('open')}}if(e.target.closest('[data-zoom-close]'))document.querySelector('[data-zoom-modal]')?.classList.remove('open')});

  document.addEventListener('click',async event=>{
    const sizeTab=event.target.closest('[data-size-unit]');
    if(sizeTab){
      const unit=sizeTab.dataset.sizeUnit;
      document.querySelectorAll('[data-size-unit]').forEach(tab=>{
        const active=tab===sizeTab;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active?'true':'false');
      });
      document.querySelectorAll('[data-size-panel]').forEach(panel=>{
        panel.hidden=panel.dataset.sizePanel!==unit;
      });
    }

    const removeButton=event.target.closest('[data-remove-line]');
    if(removeButton){
      removeButton.disabled=true;
      await fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:removeButton.dataset.removeLine,quantity:0})
      });
      await renderCart();
    }

    const clearButton=event.target.closest('[data-clear-cart]');
    if(clearButton){
      clearButton.disabled=true;
      clearButton.textContent='Clearing…';
      await fetch('/cart/clear.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'}
      });
      if(document.querySelector('[data-cart-page-form]')){
        window.location.reload();
      }else{
        await renderCart();
      }
    }
  });

});
